// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.7 11.25C2.9 11.25 1.5 9.8 1.5 8C1.5 6.2 2.9 4.75 4.7 4.75C7.35 4.75 8.65 11.25 11.3 11.25C13.1 11.25 14.5 9.8 14.5 8C14.5 6.2 13.1 4.75 11.3 4.75C8.65 4.75 7.35 11.25 4.7 11.25Z',
];
